import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import React from "react";
import Popover from "@mui/material/Popover";
const PREFIX = "MoreInfo";

const classes = {
  popover: `${PREFIX}-popover`,
  paper: `${PREFIX}-paper`,
  widePaper: `${PREFIX}-widePaper`,
  margin: `${PREFIX}-margin`,
  relativeContainer: `${PREFIX}-relativeContainer`,
  absolutePosition: `${PREFIX}-absolutePosition`,
  moreInfo: `${PREFIX}-moreInfo`,
  alignToTop: `${PREFIX}-alignToTop`,
  cacheSetup: `${PREFIX}-cacheSetup`,
  createCustomStudy: `${PREFIX}-createCustomStudy`,
  upALittleToTheRight: `${PREFIX}-upALittleToTheRight`,
  createStudy: `${PREFIX}-createStudy`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.popover}`]: {
    pointerEvents: "none",
  },

  [`& .${classes.paper}`]: {
    padding: theme.spacing(1),
    maxWidth: "450px",
  },

  [`& .${classes.widePaper}`]: {
    padding: theme.spacing(1),
    width: "60vw",
    position: "absolute",
    top: "50% !important",
    left: "50% !important",
    transform: "translate(-50%, -50%) !important",
  },

  [`& .${classes.margin}`]: {
    margin: theme.spacing(2),
    marginBottom: theme.spacing(7),
  },

  [`& .${classes.relativeContainer}`]: {
    position: "relative",
    width: 0,
    height: 0,
  },

  [`& .${classes.absolutePosition}`]: {
    position: "absolute",
    left: 8,
    top: -100,
  },

  [`& .${classes.moreInfo}`]: {
    alignSelf: "center",
    position: "relative",
    left: "8px",
  },

  [`& .${classes.alignToTop}`]: {
    position: "relative",
    left: "8px",
  },

  [`& .${classes.cacheSetup}`]: {
    position: "relative",
  },

  [`& .${classes.createCustomStudy}`]: {
    position: "relative",
    right: theme.spacing(3),
    top: theme.spacing(0.5),
  },

  [`& .${classes.upALittleToTheRight}`]: {
    position: "relative",
    left: "4px",
    bottom: "10px",
  },

  [`& .${classes.createStudy}`]: {
    position: "absolute",
    left: 10,
    top: 10,
  },
}));

export default function MoreInfo(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    if (anchorEl) {
      setAnchorEl(null); 
    } else {
      setAnchorEl(event.currentTarget); 
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  return (
    <Root
      className={
        props.outerContainerClassName
          ? classes[props.outerContainerClassName]
          : ""
      }
    >
      <div
        className={
          props.middleContainerClassName
            ? classes[props.middleContainerClassName]
            : ""
        }
      >
        <div
          className={
            props.innerContainerClassName
              ? classes[props.innerContainerClassName]
              : ""
          }
        >
          <InfoOutlinedIcon
            color="primary"
            fontSize="small"
            aria-owns={open ? "click-popover" : undefined}
            aria-haspopup="true"
            onClick={handleClick}
            style={{ cursor: "pointer" }}
          />
        </div>
      </div>
      <Popover
        id="click-popover"
        classes={{
          paper: props.widePaper ? classes.widePaper : classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: props.leftRight === "right" ? "left" : "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: props.leftRight || "left",
        }}
        onClose={handleClose}
        disableRestoreFocus
      >
        {props.popupArray
          ? props.popupArray.map((text, index) => (
              <Typography key={index} paragraph component="span">
                {text}
              </Typography>
            ))
          : <span>{props.popup}</span>}
      </Popover>
    </Root>
  );
}